/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Button, Stack } from "@mui/material";
import React from "react";
import { useAuthDialog } from "@/src/provider/AuthDialog/AuthDialogProvider";
import { headerActionsStyle } from "@/src/components/HeaderActions/headerActionsStyle";

export default function HeaderActions() {
  const { setView } = useAuthDialog();

  return (
    <Stack direction={"row"} spacing={"1rem"} sx={{ width: "100%" }}>
      <Button variant={"outlined"} size={"small"} sx={{ flexGrow: 1 }} onClick={() => setView({ type: "register" })}>
        Registrieren
      </Button>
      <Button variant={"contained"} size={"small"} onClick={() => setView({ type: "login" })} sx={headerActionsStyle.loginButton}>
        Anmelden
      </Button>
    </Stack>
  );
}
